import script from "./GroupData.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupData.vue?vue&type=script&setup=true&lang=js"

import "./GroupData.vue?vue&type=style&index=0&id=32414a0b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Downloads\\GisDungChung-WebApp-source_server_songcong\\GisDungChung-WebApp-source_server_songcong\\admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32414a0b"]])

export default __exports__